'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.containsHtmlTag = containsHtmlTag;
function containsHtmlTag(value) {
    var input = value || '';
    var htmlTagPattern = /(?:<|%3[Cc]|%[Cc])\/?[A-Za-z][A-Za-z0-9:-]*(?=[\s/>%]|$)/;
    var decoded = input;
    try {
        decoded = decodeURIComponent(input);
    } catch (e) {
        // Validate malformed URL encodings as submitted.
    }

    return htmlTagPattern.test(decodeHtmlEntities(decoded));
}

function decodeHtmlEntities(value) {
    var namedEntities = { lt: '<', gt: '>', sol: '/', tab: '\t', newline: '\n' };
    return value.replace(/&(#x[0-9a-f]+|#\d+|lt|gt|sol|tab|newline);/gi, function (entity, code) {
        if (code[0] !== '#') return namedEntities[code.toLowerCase()];
        return String.fromCharCode(parseInt(code.substring(code[1].toLowerCase() === 'x' ? 2 : 1), code[1].toLowerCase() === 'x' ? 16 : 10));
    });
}


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/validation/noHtml.js
// module id = 159
// module chunks = 0 1 2